const CarouselItems = [
  {
    src: "assets/chefphoto.jpeg",
    altText: "Chef Aran Chen",
  },
  {
    src: "https://images.pexels.com/photos/8092342/pexels-photo-8092342.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    altText: "Owner Komen Chen",
  },
  {
    src: "https://images.pexels.com/photos/2403391/pexels-photo-2403391.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    altText: "A chef prepping a dish",
  },
  {
    src: "https://images.unsplash.com/photo-1577106263724-2c8e03bfe9cf?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80",
    altText: "A chef plating a dish",
  },
  {
    src: "https://images.pexels.com/photos/3338497/pexels-photo-3338497.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    altText: "Chef seasoning edamame",
  },
];

export default CarouselItems;
